const SIMULATED_DELAY_MS = 240;

const PARTS_CATALOG = [
  {
    id: "part-001",
    name: "Bremsbelagsatz Vorderachse",
    brand: "ATE",
    category: "Bremsen",
    partNumber: "13.0460-7117.2",
    oeReferences: ["5Q0 698 151 F", "8V0 698 151 A", "1K0 698 151 J"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1517202383675-eb0a6e0b6d0c?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 79.9,
    currency: "EUR",
    offersCount: 3,
    availability: { status: "IN_STOCK", quantity: 18, leadTimeDays: 1 },
    relevanceScore: 0.92,
  },
  {
    id: "part-002",
    name: "Bremsscheibe belüftet",
    brand: "Brembo",
    category: "Bremsen",
    partNumber: "09.A921.14",
    oeReferences: ["5G0 615 301 L", "5G0 615 301 G"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 114.5,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "LOW_STOCK", quantity: 4, leadTimeDays: 2 },
    relevanceScore: 0.87,
  },
  {
    id: "part-003",
    name: "Ölfilter Eco",
    brand: "MANN-FILTER",
    category: "Filter",
    partNumber: "W 712/94",
    oeReferences: ["03C 115 561 H", "03C 115 561 D"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 12.6,
    currency: "EUR",
    offersCount: 5,
    availability: { status: "IN_STOCK", quantity: 120, leadTimeDays: 0 },
    relevanceScore: 0.95,
  },
  {
    id: "part-004",
    name: "Innenraumfilter Aktivkohle",
    brand: "Bosch",
    category: "Filter",
    partNumber: "0 986 628 585",
    oeReferences: ["5Q0 819 653", "5Q0 819 653 A"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 24.9,
    currency: "EUR",
    offersCount: 4,
    availability: { status: "IN_STOCK", quantity: 35, leadTimeDays: 1 },
    relevanceScore: 0.81,
  },
  {
    id: "part-005",
    name: "Zündkerze Iridium",
    brand: "NGK",
    category: "Zündung",
    partNumber: "95875 ILZKR7B-11S",
    oeReferences: ["04E 905 612 C", "04E 905 612"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 18.2,
    currency: "EUR",
    offersCount: 6,
    availability: { status: "IN_STOCK", quantity: 80, leadTimeDays: 0 },
    relevanceScore: 0.89,
  },
  {
    id: "part-006",
    name: "Glühlampe Xenon",
    brand: "Osram",
    category: "Beleuchtung",
    partNumber: "D3S 35W",
    oeReferences: ["4G0 941 941", "8K0 941 997"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1494972308805-463bc619d34e?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 64.5,
    currency: "EUR",
    offersCount: 3,
    availability: { status: "LOW_STOCK", quantity: 6, leadTimeDays: 3 },
    relevanceScore: 0.75,
  },
  {
    id: "part-007",
    name: "Stoßdämpfer Hinterachse",
    brand: "Sachs",
    category: "Fahrwerk",
    partNumber: "313 291",
    oeReferences: ["5Q0 513 025 BR", "5Q0 513 025 CF"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1511919884226-fd3cad34687c?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 142.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "IN_STOCK", quantity: 14, leadTimeDays: 2 },
    relevanceScore: 0.9,
  },
  {
    id: "part-008",
    name: "Querlenker Vorderachse links",
    brand: "Lemförder",
    category: "Fahrwerk",
    partNumber: "35497 01",
    oeReferences: ["5Q0 407 151 C", "5Q0 407 151 F"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 189.5,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "IN_STOCK", quantity: 9, leadTimeDays: 2 },
    relevanceScore: 0.78,
  },
  {
    id: "part-009",
    name: "Scheinwerfereinheit LED rechts",
    brand: "HELLA",
    category: "Beleuchtung",
    partNumber: "1EL 011 891-421",
    oeReferences: ["5G1 941 753", "5G1 941 753 B"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 684.0,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "LOW_STOCK", quantity: 1, leadTimeDays: 5 },
    relevanceScore: 0.7,
  },
  {
    id: "part-010",
    name: "Batterie AGM 70Ah",
    brand: "Varta",
    category: "Elektrik",
    partNumber: "E39",
    oeReferences: ["000 915 105 DH", "000 915 105 DL"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 158.3,
    currency: "EUR",
    offersCount: 4,
    availability: { status: "IN_STOCK", quantity: 22, leadTimeDays: 1 },
    relevanceScore: 0.74,
  },
  {
    id: "part-011",
    name: "Luftmassenmesser",
    brand: "Bosch",
    category: "Motor",
    partNumber: "0 281 006 535",
    oeReferences: ["03L 906 461", "03L 906 461 A"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 139.0,
    currency: "EUR",
    offersCount: 3,
    availability: { status: "IN_STOCK", quantity: 11, leadTimeDays: 1 },
    relevanceScore: 0.83,
  },
  {
    id: "part-012",
    name: "Turbolader",
    brand: "Garrett",
    category: "Motor",
    partNumber: "781504-5004S",
    oeReferences: ["04L 253 010 L", "04L 253 056 C"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 920.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "LOW_STOCK", quantity: 2, leadTimeDays: 4 },
    relevanceScore: 0.69,
  },
  {
    id: "part-013",
    name: "Kupplungssatz",
    brand: "LuK",
    category: "Antrieb",
    partNumber: "600 0017 00",
    oeReferences: ["03L 141 015 P", "03L 141 015 T"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 368.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "IN_STOCK", quantity: 7, leadTimeDays: 3 },
    relevanceScore: 0.82,
  },
  {
    id: "part-014",
    name: "Kühlmittelpumpe elektrisch",
    brand: "Pierburg",
    category: "Motor",
    partNumber: "7.05591.24.0",
    oeReferences: ["5Q0 965 561 B", "5Q0 965 561 C"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1518481852122-48db268ec5c2?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 214.4,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "LOW_STOCK", quantity: 3, leadTimeDays: 5 },
    relevanceScore: 0.64,
  },
  {
    id: "part-015",
    name: "Türscharnier Reparatursatz",
    brand: "VW",
    category: "Karosserie",
    partNumber: "5G0 898 998",
    oeReferences: ["5G0 831 401", "5G0 831 402"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1512495965583-37f52a84f8c0?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: null,
    currency: "EUR",
    offersCount: 0,
    availability: { status: "OUT_OF_STOCK", quantity: 0, leadTimeDays: 10 },
    relevanceScore: 0.6,
  },
  {
    id: "part-016",
    name: "Scheibenwischerblatt Set",
    brand: "Bosch",
    category: "Karosserie",
    partNumber: "3 397 118 911",
    oeReferences: ["5G1 955 425", "5G1 955 426"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1549923746-c502d488b3ea?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 29.5,
    currency: "EUR",
    offersCount: 6,
    availability: { status: "IN_STOCK", quantity: 55, leadTimeDays: 0 },
    relevanceScore: 0.88,
  },
  {
    id: "part-017",
    name: "Sensor Reifendruckkontrolle",
    brand: "Continental",
    category: "Elektrik",
    partNumber: "3AA 907 275",
    oeReferences: ["5Q0 907 275", "5Q0 907 275 B"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 54.7,
    currency: "EUR",
    offersCount: 4,
    availability: { status: "IN_STOCK", quantity: 26, leadTimeDays: 1 },
    relevanceScore: 0.73,
  },
  {
    id: "part-018",
    name: "AGR-Ventil",
    brand: "Pierburg",
    category: "Motor",
    partNumber: "7.24809.47.0",
    oeReferences: ["03L 131 501 Q", "03L 131 501 S"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 268.0,
    currency: "EUR",
    offersCount: 3,
    availability: { status: "LOW_STOCK", quantity: 5, leadTimeDays: 3 },
    relevanceScore: 0.71,
  },
  {
    id: "part-019",
    name: "Radlager Vorderachse",
    brand: "SKF",
    category: "Fahrwerk",
    partNumber: "VKBA 6549",
    oeReferences: ["5Q0 498 621", "5Q0 498 621 A"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 112.0,
    currency: "EUR",
    offersCount: 3,
    availability: { status: "IN_STOCK", quantity: 18, leadTimeDays: 2 },
    relevanceScore: 0.84,
  },
  {
    id: "part-020",
    name: "Kraftstofffilter",
    brand: "Mahle",
    category: "Filter",
    partNumber: "KL 572",
    oeReferences: ["5Q0 127 177", "5Q0 127 401"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 43.2,
    currency: "EUR",
    offersCount: 4,
    availability: { status: "IN_STOCK", quantity: 44, leadTimeDays: 1 },
    relevanceScore: 0.86,
  },
  {
    id: "part-021",
    name: "Bremsflüssigkeit DOT4",
    brand: "ATE",
    category: "Bremsen",
    partNumber: "03.9901-5802.2",
    oeReferences: ["G 052 150 A2"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1527345931282-806d3b3c0f8c?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 11.9,
    currency: "EUR",
    offersCount: 5,
    availability: { status: "IN_STOCK", quantity: 96, leadTimeDays: 0 },
    relevanceScore: 0.8,
  },
  {
    id: "part-022",
    name: "Stoßfänger vorne grundiert",
    brand: "Van Wezel",
    category: "Karosserie",
    partNumber: "5870504",
    oeReferences: ["5G0 807 217 AL"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 325.0,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "OUT_OF_STOCK", quantity: 0, leadTimeDays: 12 },
    relevanceScore: 0.58,
  },
  {
    id: "part-023",
    name: "Lenkgetriebe elektrisch",
    brand: "TRW",
    category: "Lenkung",
    partNumber: "JRM1285",
    oeReferences: ["5QM 909 144", "5Q1 909 144"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 1240.0,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "LOW_STOCK", quantity: 1, leadTimeDays: 7 },
    relevanceScore: 0.62,
  },
  {
    id: "part-024",
    name: "Federnsatz Vorderachse",
    brand: "Eibach",
    category: "Fahrwerk",
    partNumber: "E10-85-041-01-22",
    oeReferences: ["5G0 411 105 BK", "5G0 411 105 BN"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 286.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "LOW_STOCK", quantity: 4, leadTimeDays: 6 },
    relevanceScore: 0.67,
  },
  {
    id: "part-025",
    name: "Innenraumgebläse",
    brand: "Valeo",
    category: "Innenraum",
    partNumber: "715716",
    oeReferences: ["5Q1 819 015", "5Q1 819 015 C"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1471479917193-f00955256257?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 214.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "IN_STOCK", quantity: 8, leadTimeDays: 2 },
    relevanceScore: 0.68,
  },
  {
    id: "part-026",
    name: "Heckleuchtensatz LED",
    brand: "HELLA",
    category: "Beleuchtung",
    partNumber: "2SA 013 053-031",
    oeReferences: ["5G0 945 207 Q", "5G0 945 208 Q"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 448.0,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "LOW_STOCK", quantity: 2, leadTimeDays: 5 },
    relevanceScore: 0.65,
  },
  {
    id: "part-027",
    name: "Steuerkette Reparatursatz",
    brand: "INA",
    category: "Motor",
    partNumber: "559 0122 10",
    oeReferences: ["04E 198 119 H", "04E 198 119 A"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 389.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "IN_STOCK", quantity: 6, leadTimeDays: 3 },
    relevanceScore: 0.85,
  },
  {
    id: "part-028",
    name: "Antriebswelle rechts",
    brand: "GKN",
    category: "Antrieb",
    partNumber: "305415",
    oeReferences: ["5Q0 407 272 GX", "5Q0 407 272 FX"],
    fitmentScore: "UNSURE",
    imageUrl:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 512.0,
    currency: "EUR",
    offersCount: 1,
    availability: { status: "LOW_STOCK", quantity: 3, leadTimeDays: 6 },
    relevanceScore: 0.7,
  },
  {
    id: "part-029",
    name: "Domlager Vorderachse",
    brand: "SKF",
    category: "Fahrwerk",
    partNumber: "VKDA 88506",
    oeReferences: ["5Q0 412 331 F", "5Q0 412 331 G"],
    fitmentScore: "SAFE",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 82.5,
    currency: "EUR",
    offersCount: 4,
    availability: { status: "IN_STOCK", quantity: 32, leadTimeDays: 1 },
    relevanceScore: 0.79,
  },
  {
    id: "part-030",
    name: "LED-Nebelscheinwerfer",
    brand: "Osram",
    category: "Beleuchtung",
    partNumber: "LEDriving F1",
    oeReferences: ["5Q0 941 699", "5Q0 941 700"],
    fitmentScore: "UNKNOWN",
    imageUrl:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?auto=format&fit=crop&w=800&q=80",
    bestOfferPrice: 192.0,
    currency: "EUR",
    offersCount: 2,
    availability: { status: "LOW_STOCK", quantity: 5, leadTimeDays: 4 },
    relevanceScore: 0.66,
  },
];

const AVAILABILITY_RANK = {
  IN_STOCK: 3,
  LOW_STOCK: 2,
  OUT_OF_STOCK: 1,
  UNKNOWN: 0,
};

function delay(value) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(value), SIMULATED_DELAY_MS);
  });
}

function normalizeArray(value) {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}

function includesTerm(value, term) {
  if (!term) {
    return true;
  }
  if (!value) {
    return false;
  }
  return value.toLowerCase().includes(term);
}

function computeSearchScore(part, term) {
  let score = typeof part.relevanceScore === "number" ? part.relevanceScore : 0.5;

  if (part.fitmentScore === "SAFE") {
    score += 0.08;
  } else if (part.fitmentScore === "UNSURE") {
    score -= 0.05;
  }

  if (!term) {
    return Math.max(0, Math.min(1, score));
  }

  const haystack = [
    part.name,
    part.brand,
    part.category,
    part.partNumber,
    ...(Array.isArray(part.oeReferences) ? part.oeReferences : []),
  ]
    .filter(Boolean)
    .map((value) => value.toLowerCase());

  let scoreBoost = 0;
  haystack.forEach((value) => {
    if (value === term) {
      scoreBoost = Math.max(scoreBoost, 0.35);
    } else if (value.startsWith(term)) {
      scoreBoost = Math.max(scoreBoost, 0.25);
    } else if (value.includes(term)) {
      scoreBoost = Math.max(scoreBoost, 0.15);
    }
  });
  const totalScore = score + scoreBoost;
  return Math.max(0, Math.min(1, totalScore));
}

function buildFacetList(countMap, selectedValues = []) {
  const result = Array.from(countMap.entries()).map(([value, count]) => ({
    value,
    label: value,
    count,
  }));

  selectedValues.forEach((value) => {
    if (!countMap.has(value)) {
      result.push({ value, label: value, count: 0 });
    }
  });

  return result.sort((a, b) => a.label.localeCompare(b.label, "de-DE", { sensitivity: "base" }));
}

export async function searchPartsCatalog({
  search = "",
  categories = [],
  brands = [],
  sort = "RELEVANCE",
  page = 1,
  pageSize = 12,
  fitmentOnly = false,
} = {}) {
  const normalizedSearch = search.trim().toLowerCase();
  const normalizedCategories = normalizeArray(categories)
    .map((value) => String(value))
    .filter(Boolean);
  const normalizedBrands = normalizeArray(brands)
    .map((value) => String(value))
    .filter(Boolean);
  const sanitizedPageSize = Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 12;
  const safeFitmentOnly = Boolean(fitmentOnly);

  const searchFiltered = PARTS_CATALOG.filter((part) => {
    if (normalizedSearch) {
      const matchesSearch =
        includesTerm(part.name, normalizedSearch) ||
        includesTerm(part.brand, normalizedSearch) ||
        includesTerm(part.category, normalizedSearch) ||
        includesTerm(part.partNumber, normalizedSearch) ||
        (Array.isArray(part.oeReferences) &&
          part.oeReferences.some((ref) => includesTerm(ref, normalizedSearch)));
      if (!matchesSearch) {
        return false;
      }
    }
    return true;
  });

  const initialFiltered = safeFitmentOnly
    ? searchFiltered.filter((part) => part.fitmentScore === "SAFE")
    : searchFiltered;

  const categoryCountMap = new Map();
  const brandCountMap = new Map();

  initialFiltered.forEach((part) => {
    if (part.category) {
      categoryCountMap.set(part.category, (categoryCountMap.get(part.category) ?? 0) + 1);
    }
    if (part.brand) {
      brandCountMap.set(part.brand, (brandCountMap.get(part.brand) ?? 0) + 1);
    }
  });

  let filtered = initialFiltered;

  if (normalizedCategories.length > 0) {
    filtered = filtered.filter((part) => normalizedCategories.includes(part.category));
  }

  if (normalizedBrands.length > 0) {
    filtered = filtered.filter((part) => normalizedBrands.includes(part.brand));
  }

  const sortMode = String(sort).toUpperCase();

  const sorted = [...filtered].sort((a, b) => {
    if (sortMode === "PRICE") {
      const priceA = typeof a.bestOfferPrice === "number" ? a.bestOfferPrice : Number.POSITIVE_INFINITY;
      const priceB = typeof b.bestOfferPrice === "number" ? b.bestOfferPrice : Number.POSITIVE_INFINITY;
      if (priceA === priceB) {
        return computeSearchScore(b, normalizedSearch) - computeSearchScore(a, normalizedSearch);
      }
      return priceA - priceB;
    }

    if (sortMode === "AVAILABILITY") {
      const rankA = AVAILABILITY_RANK[a.availability?.status] ?? AVAILABILITY_RANK.UNKNOWN;
      const rankB = AVAILABILITY_RANK[b.availability?.status] ?? AVAILABILITY_RANK.UNKNOWN;
      if (rankA === rankB) {
        const priceA = typeof a.bestOfferPrice === "number" ? a.bestOfferPrice : Number.POSITIVE_INFINITY;
        const priceB = typeof b.bestOfferPrice === "number" ? b.bestOfferPrice : Number.POSITIVE_INFINITY;
        if (priceA === priceB) {
          return computeSearchScore(b, normalizedSearch) - computeSearchScore(a, normalizedSearch);
        }
        return priceA - priceB;
      }
      return rankB - rankA;
    }

    const scoreA = computeSearchScore(a, normalizedSearch);
    const scoreB = computeSearchScore(b, normalizedSearch);
    if (scoreA === scoreB) {
      return (a.name || "").localeCompare(b.name || "", "de-DE", { sensitivity: "base" });
    }
    return scoreB - scoreA;
  });

  const total = sorted.length;
  const totalPages = total > 0 ? Math.ceil(total / sanitizedPageSize) : 1;
  const normalizedPage = Math.min(Math.max(page, 1), totalPages);
  const startIndex = (normalizedPage - 1) * sanitizedPageSize;
  const items = sorted.slice(startIndex, startIndex + sanitizedPageSize);

  return delay({
    items,
    total,
    page: normalizedPage,
    pageSize: sanitizedPageSize,
    facets: {
      categories: buildFacetList(categoryCountMap, normalizedCategories),
      brands: buildFacetList(brandCountMap, normalizedBrands),
    },
  });
}

